import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["closable", "clsPrefix", "className", "style", "children", "color", "title", "content", "onEnd", "onClose", "duration"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Icon from '../../wui-icon/src';
var propTypes = {
  duration: PropTypes.number,
  onClose: PropTypes.func,
  children: PropTypes.any,
  color: PropTypes.oneOf(['info', 'success', 'danger', 'warning', 'light', 'dark', 'news', 'infolight', 'successlight', 'dangerlight', 'warninglight']),
  title: PropTypes.any
};

function noop() {}

var defaultProps = {
  onEnd: noop,
  onClose: noop,
  duration: 4.5,
  closable: true,
  color: "light"
};

var Notice = /*#__PURE__*/function (_React$Component) {
  _inherits(Notice, _React$Component);

  var _super = _createSuper(Notice);

  function Notice(props) {
    var _this;

    _classCallCheck(this, Notice);

    _this = _super.call(this, props);
    _this.clearCloseTimer = _this.clearCloseTimer.bind(_assertThisInitialized(_this));
    _this.close = _this.close.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Notice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.duration) {
        this.closeTimer = setTimeout(function () {
          _this2.close();
        }, this.props.duration * 1000);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: "clearCloseTimer",
    value: function clearCloseTimer() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.clearCloseTimer();
      this.props.onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var _this$props = this.props,
          closable = _this$props.closable,
          clsPrefix = _this$props.clsPrefix,
          className = _this$props.className,
          style = _this$props.style,
          children = _this$props.children,
          color = _this$props.color,
          title = _this$props.title,
          content = _this$props.content,
          onEnd = _this$props.onEnd,
          onClose = _this$props.onClose,
          duration = _this$props.duration,
          others = _objectWithoutProperties(_this$props, _excluded);

      var componentClass = "".concat(clsPrefix, "-notice");
      var classes = (_classes = {}, _defineProperty(_classes, "".concat(componentClass), 1), _defineProperty(_classes, "".concat(componentClass, "-closable"), closable), _defineProperty(_classes, className, !!className), _classes);
      var iconType = {
        info: 'uf uf-i-c',
        success: 'uf uf-correct',
        danger: 'uf uf-exc-c',
        warning: 'uf uf-exc-t',
        light: 'uf',
        dark: 'uf',
        news: 'uf uf-bell',
        infolight: 'uf uf-i-c',
        successlight: 'uf uf-correct',
        dangerlight: 'uf uf-exc-c',
        warninglight: 'uf uf-exc-t'
      }[color]; // bip:强制转成light风格

      var mapping = {
        success: "successlight",
        info: "infolight",
        danger: "dangerlight",
        warning: "warninglight"
      };

      if (color) {
        var tempColor = color in mapping ? mapping[color] : color;
        classes["".concat(componentClass, "-").concat(tempColor)] = true;
      }

      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames(classes),
        style: style,
        onClick: this.close
      }, others), /*#__PURE__*/React.createElement("div", {
        className: "".concat(componentClass, "-content")
      }, title && /*#__PURE__*/React.createElement("div", {
        className: "".concat(componentClass, "-title")
      }, /*#__PURE__*/React.createElement("i", {
        className: iconType
      }), title), /*#__PURE__*/React.createElement("div", {
        className: "".concat(componentClass, "-description")
      }, children)), closable ? /*#__PURE__*/React.createElement("a", {
        tabIndex: "0",
        onClick: this.close,
        className: "".concat(componentClass, "-close")
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(componentClass, "-close-x")
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "uf-close"
      }))) : null);
    }
  }]);

  return Notice;
}(React.Component);

;
Notice.propTypes = propTypes;
Notice.defaultProps = defaultProps;
export default Notice;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-notification/src/Notice.js